import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

function Formations() {
  const navigate = useNavigate();

  const formations = [
    {
      id: 1,
      icon: '🎯',
      title: 'Outil Internet de Prospection Massive',
      description: 'Découvre la méthode complète pour prospecter massivement sur Internet sans être perçu comme un spammeur. Cette formation te donne les outils et techniques pour générer des leads qualifiés de manière automatisée.',
      benefits: [
        'Prospecte 10x plus vite qu\'avec les méthodes traditionnelles',
        'Technique 100% respectueuse et non intrusive',
        'Génération de leads qualifiés en autopilot',
        'Scripts et templates prêts à l\'emploi'
      ],
      price: 'Formation Payante',
      link: 'https://www.blogueurmlm.com/video-de-formationq61bh9vg',
      level: 'Débutant à Intermédiaire',
      color: '#3b82f6'
    },
    {
      id: 2,
      icon: '🥷',
      title: 'L\'École du Networker',
      description: 'La formation COMPLÈTE pour maîtriser tous les aspects du MLM et du networking. De la prospection à la duplication, en passant par le leadership et la gestion d\'équipe. Tout ce dont tu as besoin pour devenir un networker d\'élite.',
      benefits: [
        'Formation complète de A à Z sur le MLM',
        'Techniques de duplication éprouvées',
        'Développement du leadership',
        'Accompagnement et suivi personnalisé',
        'Accès à une communauté de networkers'
      ],
      price: 'Formation Payante',
      link: 'https://www.ninja-elite.com/ecoledunetworker?sa=sa000295432252cdc3c1d7fb371772d53f3d2cbae6db',
      level: 'Tous niveaux',
      color: '#8b5cf6'
    }
  ];

  const outils = [
    {
      id: 1,
      icon: '⚙️',
      title: 'Système.io',
      description: 'L\'outil tout-en-un utilisé par les networkers professionnels pour automatiser leur business MLM. Création de tunnels de vente, email marketing, automatisation, gestion de formations en ligne... Tout ce qu\'il te faut en une seule plateforme.',
      benefits: [
        'Tunnel de vente clé en main',
        'Email marketing automatisé',
        'Pages de capture et landing pages',
        'Hébergement de formations en ligne',
        'Espace membre pour tes filleuls',
        'Intégration paiement Stripe/PayPal'
      ],
      link: 'https://blog.amsweb.fr/systemeio-fr',
      badge: 'Recommandé par Fred',
      color: '#10b981'
    }
  ];

  return (
    <div className="app">
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
            <span className="logo-text">AmsWeb</span>
            <span className="logo-subtitle">Aide MultiServices du Web</span>
          </div>
          <div className="nav-links">
            <a href="/" className="nav-link">Accueil</a>
            <a href="/#formations" className="nav-link">Formations</a>
            <a href="/#blog" className="nav-link">Blog</a>
            <a href="/#contact" className="nav-link nav-cta">Contact</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="formations-hero">
        <div className="container">
          <h1 className="formations-hero-title">
            🎓 Formations & Outils pour Réussir Ton MLM
          </h1>
          <p className="formations-hero-subtitle">
            Découvre les ressources que j'utilise et recommande pour développer ton activité MLM.<br />
            Des formations éprouvées et des outils professionnels utilisés par les meilleurs networkers.
          </p>
        </div>
      </section>

      {/* Formations Section */}
      <section className="formations-list-section">
        <div className="container">
          <h2 className="section-title">
            📚 Nos Formations MLM Exclusives
          </h2>
          <p className="section-subtitle">
            Des formations payantes de qualité pour transformer ton approche du MLM
          </p>

          <div className="formations-grid">
            {formations.map((formation) => (
              <div key={formation.id} className="formation-card" data-testid={`formation-card-${formation.id}`}>
                <div className="formation-header" style={{borderColor: formation.color}}>
                  <div className="formation-icon-large" style={{background: formation.color}}>
                    {formation.icon}
                  </div>
                  <div className="formation-level">{formation.level}</div>
                </div>
                <div className="formation-body">
                  <h3>{formation.title}</h3>
                  <p className="formation-description">{formation.description}</p>
                  
                  <div className="formation-benefits">
                    <h4>✨ Ce que tu vas apprendre :</h4>
                    <ul>
                      {formation.benefits.map((benefit, index) => (
                        <li key={index}>✓ {benefit}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="formation-footer">
                    <div className="formation-price">{formation.price}</div>
                    <a 
                      href={formation.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                      style={{background: formation.color}}
                      data-testid={`formation-cta-${formation.id}`}
                    >
                      Découvrir la Formation 🚀
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Outils Section */}
      <section className="outils-section">
        <div className="container">
          <h2 className="section-title">
            🛠️ Les Outils Indispensables
          </h2>
          <p className="section-subtitle">
            Les outils que j'utilise personnellement et que je recommande à tous mes filleuls
          </p>

          <div className="outils-grid">
            {outils.map((outil) => (
              <div key={outil.id} className="outil-card" data-testid={`outil-card-${outil.id}`}>
                {outil.badge && (
                  <div className="outil-badge">{outil.badge}</div>
                )}
                <div className="outil-icon-large" style={{background: outil.color}}>
                  {outil.icon}
                </div>
                <h3>{outil.title}</h3>
                <p className="outil-description">{outil.description}</p>
                
                <div className="outil-benefits">
                  <h4>🎯 Fonctionnalités :</h4>
                  <ul>
                    {outil.benefits.map((benefit, index) => (
                      <li key={index}>✓ {benefit}</li>
                    ))}
                  </ul>
                </div>
                
                <a 
                  href={outil.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-large"
                  style={{background: outil.color, color: 'white'}}
                  data-testid={`outil-cta-${outil.id}`}
                >
                  Découvrir {outil.title} 💪
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="formations-cta-section">
        <div className="container">
          <div className="formations-cta-content">
            <h2>🤔 Besoin d'Aide pour Choisir ?</h2>
            <p>
              Tu hésites entre les formations ? Tu veux savoir laquelle correspond le mieux à ton niveau ?<br />
              <strong>Contacte-moi directement, je te guide gratuitement !</strong>
            </p>
            <div className="cta-buttons">
              <button 
                onClick={() => {
                  navigate('/');
                  setTimeout(() => {
                    const contactSection = document.querySelector('#contact');
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                  }, 100);
                }}
                className="btn btn-primary btn-large"
                data-testid="contact-fred-cta"
              >
                ✉️ Contacte Fred
              </button>
              <button 
                onClick={() => {
                  navigate('/');
                  setTimeout(() => {
                    const contactSection = document.querySelector('#contact');
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                  }, 100);
                }}
                className="btn btn-secondary btn-large"
                data-testid="back-to-contact-form"
              >
                📝 Formulaire de Contact
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>AmsWeb</h3>
              <p>Aide MultiServices du Web</p>
              <p className="footer-tagline">Toutes les astuces pour développer ton MLM et être au Top sur le Net</p>
            </div>
            <div className="footer-section">
              <h4>Navigation</h4>
              <ul className="footer-links">
                <li><a href="/">Accueil</a></li>
                <li><a href="/formations-outils">Formations & Outils</a></li>
                <li><a href="/#blog">Blog</a></li>
                <li><a href="/#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>✉️ <a href="mailto:contact@amsweb.fr">contact@amsweb.fr</a></p>
              <p className="footer-fred">Avec Fred d'AmsWeb</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 AmsWeb.fr - Tous droits réservés</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Formations;